import React, {useEffect} from 'react';
import MoneyDeliveryStatsProperties from "./MoneyDeliveryStatsProperties";
import {useStyles} from "./MoneyDeliveryStats.style";
import MoneyDeliveryStatsStore from "./MoneyDeliveryStatsStore";
import {useCommonContext} from "../../../contexts/CommonContext";
import {Observer} from "mobx-react-lite";
import clsx from "clsx";
import PageLoading from "../../../ui_components/PageLoading/PageLoading";
import {useI18nContext} from "../../../contexts/I18nContext";
import { useUserContext } from '../../../contexts/UserContext';

const MoneyDeliveryStats: React.FC<MoneyDeliveryStatsProperties> = ({
                                                                className = '',
                                                            }) => {

    const i18n = useI18nContext();
    const commonStore = useCommonContext();
    const userStore = useUserContext();
    const store = new MoneyDeliveryStatsStore(commonStore, userStore.currentUser()?.id);
    const classes = useStyles();

    useEffect(() => {
        store.getMoneyDeliveryStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onclick = () => {
        window.location.href = "/money-remittances";
    }

    return <Observer>{() => (
        <div className={clsx(classes.total_sales_container, classes.flex_column, className)}>
            {<div className={classes.title}>{'Servicio Dinero'}</div>}
            <div className={clsx(classes.flex_row, classes.body)}>
                {store.moneyDeliveryStats &&
                    <>
                        <div className={clsx(classes.box_container, classes.flex_column)} onClick={onclick}>
                            <div>{store.moneyDeliveryStats?.deliveryAmount || 0}</div>
                            <div>Pendientes</div>
                        </div>
                    </>}
                <PageLoading className={classes.loading_container} loadingSize={40} isLoading={store.loading}
                             text={`${i18n.translate("LOADING")} ${'Dinero' || ''}`}/>
            </div>
        </div>
    )}</Observer>

}


export default MoneyDeliveryStats;